import api from 'poly-eshop4/eshop/ui/js/container';

$(document).on('change', '[data-update-shoppinglist-position-dimension-select]', function() {
  const form = $(this).closest('form');
  const pospk = form.attr('data-pk');
  $(`#mutable_dimension_quantity_${pospk}`).val(this.value);
});

$(document).on('change', '[data-update-shoppinglist-position-dimension]', function() {
  const pospk = $(this).attr('data-pk');
  const select = $(`#dimension-quantity-${pospk}`);
  const quantity = select.val();
  const mutable = $('option:selected', select).attr('data-mutable');
  const dimensionunit = $('option:selected', select).attr('data-dimension_unit');
  const serialnumber = $('option:selected', select).attr('data-serial_number');

  $(`#mutable_dimension_quantity_${pospk}`).hide();
  $(`#mutable_dimension_quantity_${pospk}`).attr('name', '');
  $(`#dimension_quantity_${pospk}`).attr('name', 'dimension_quantity');
  $(`#dimension_quantity_${pospk}`).val(quantity);
  $(`#quantity-${pospk}`).removeAttr('disabled');
  $(`#dimension_unit_${pospk}`).val(dimensionunit);
  $(`#serial_number_${pospk}`).val(serialnumber);

  if (mutable === 'True') {
    $(`#mutable_dimension_quantity_${pospk}`).show();
    $(`#dimension_quantity_${pospk}`).attr('name', '');
    $(`#mutable_dimension_quantity_${pospk}`).attr('name', 'dimension_quantity');
  }

  if (serialnumber) {
    $(`#quantity-${pospk}`).attr('disabled', 'disabled');
    $(`#quantity-${pospk}`).val(1);
  }
  api.updateQuantity($(`#quantity-${pospk}`), 'shoppinglist');
});
